import Swiper from 'swiper/bundle'
import InfiniteScroll from 'infinite-scroll'
import imagesLoaded from 'imagesloaded'

const popular = document.querySelector('.blog-section__posts--popular')

if (popular) {
  new Swiper(popular, {
    spaceBetween: 10,
    slidesPerView: 1.2,
    breakpoints: {
      576: {
        spaceBetween: 15,
        slidesPerView: 1.3,
      },
      768: {
        spaceBetween: 15,
        slidesPerView: 1.5,
      },
      992: {
        spaceBetween: 30,
        slidesPerView: 2,
      },
    },
  })
}

const recent = document.querySelector('.blog-section__posts--recent')

if (recent) {
  new Swiper(recent, {
    spaceBetween: 15,
    slidesPerView: 1.2,
    breakpoints: {
      576: {
        spaceBetween: 15,
        slidesPerView: 1.4,
      },
      768: {
        spaceBetween: 15,
        slidesPerView: 2,
      },
      992: {
        spaceBetween: 30,
        slidesPerView: 2.5,
      },
      1200: {
        spaceBetween: 30,
        slidesPerView: 3,
      },
    },
  })
}

const slider = document.querySelector('.blog-section__posts--slider')

if (slider) {
  new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 45,
    autoHeight: true,
    navigation: {
      prevEl: slider.querySelector('.vertical-posts__nav--prev'),
      nextEl: slider.querySelector('.vertical-posts__nav--next'),
    },
  })
}

const nav = document.querySelector('.blog-posts-nav .nav-previous a')

if (nav) {
  InfiniteScroll.imagesLoaded = imagesLoaded

  const request = new InfiniteScroll('.blog-section__posts--all', {
    path: '.nav-previous a',
    append: '.feed-ajax-post',
    status: '.page-load-status',
    hideNav: '.blog-posts-nav',
    button: '.load-more',
    scrollThreshold: false,
    history: false,
  })

  const requestButton = document.querySelector('.load-more')
  let isLast = false

  request.on('request', function () {
    requestButton.style.display = 'none'
  })

  request.on('append', function () {
    if (!isLast) requestButton.style.display = ''
  })

  request.on('last', function () {
    isLast = true
  })
}
